<template>
    <tr :class="{ 'edit-row': isEditRequested }">
        <td>
            {{ dme.name }}
        </td>
        <td>
            {{ dme.isInfusionPump ? "Yes" : "No" }}
        </td>
        <td>
            <div class="form-group mb-0">
                <select class="form-select" name="related-diag" v-model="dme.isRelated" v-if="isEditRequested">
                    <option :value="null">Select Relatedness</option>
                    <option :value="true">Yes</option>
                    <option :value="false">No</option>
                </select>
            </div>
            <div v-if="!isEditRequested">
                <small v-if="!isDmeRelatedBoolean">
                    <i class="text-default">Not Available</i>
                </small>
                <span v-else>{{ dme.isRelated ? "Yes" : "No" }}</span>
                <span v-if="dme.isRelated === false" class="ms-1" v-tooltip="{ title: dme.notRelatedComments }">
                    <i class="fas fa-info-circle text-primary"></i>
                </span>
            </div>
        </td>
        <td v-if="!isDeleteRequested">
            <span v-if="!isEditRequested">
                <span v-if="dme.startDate"> {{ formatDate(dme.startDate) }} </span>
                <span v-else> - </span>
            </span>
            <DatePicker :getDate="onDateChange" v-else>
                <div class="input-group date datepickerInput">
                    <input
                        name="dmeStartDate"
                        type="text"
                        class="form-control"
                        :value="formatDateInput(dme.startDate)"
                        placeholder="MM/DD/YYYY"
                        date-format-only
                        :disabled="!isEditAllowed"
                        @blur="v$.dme.startDate.$touch"
                        :class="`${!v$.dme.startDate.$error ? '' : 'field-invalid'}`"
                    />
                    <div class="input-group-addon input-group-append">
                        <div class="input-group-text">
                            <i class="fa fa-calendar"></i>
                        </div>
                    </div>
                </div>
            </DatePicker>
        </td>
        <td v-if="!isDeleteRequested">
            <span v-if="!isEditRequested">
                <span v-if="dme.endDate">{{ formatDate(dme.endDate) }} </span>
                <span v-else> - </span>
            </span>
            <DatePicker :getDate="onDateChange" v-else>
                <div class="input-group date datepickerInput">
                    <input
                        name="dmeEndDate"
                        type="text"
                        class="form-control"
                        :value="formatDateInput(dme.endDate)"
                        placeholder="MM/DD/YYYY"
                        date-format-only
                        :disabled="!isEditAllowed"
                    />
                    <div class="input-group-addon input-group-append">
                        <div class="input-group-text">
                            <i class="fa fa-calendar"></i>
                        </div>
                    </div>
                </div>
            </DatePicker>
        </td>
        <!-- ACTIONS -->
        <td class="text-end" v-if="!isEditRequested && !isDeleteRequested">
            <button type="button" class="btn table-btn btn-outline-info" @click="editDme()">
                <i class="fas fa-edit"></i>
            </button>
            <button
                type="button"
                class="btn table-btn btn-outline-danger"
                v-if="!dme.id && isEditAllowed"
                @click="requestDeleteDme()"
            >
                <i class="fas fa-trash-alt"></i>
            </button>
        </td>
        <!-- EDIT -->
        <td class="button-cell text-end" v-if="isEditRequested">
            <button type="button" class="btn table-btn btn-outline-success" @click="saveEdit()">Save</button>
            <button type="button" class="btn table-btn btn-outline-secondary" @click="cancelEdit()">Cancel</button>
        </td>
        <!-- DELETE -->
        <td colspan="3" v-show="isDeleteRequested">
            <TablePrompt
                :message="`Are you sure want to delete ${dme.name}?`"
                ok-text="delete"
                name="Delete"
                :ok="deleteDme"
                :cancel="cancelDelete"
            >
            </TablePrompt>
        </td>
    </tr>
    <tr v-if="isEditRequested && dme.isRelated === false" class="row-no-hover edit-row">
        <td :colspan="columns" class="p-2 edit">
            <div class="d-flex flex-column align-items-center">
                <div class="form-group w-50">
                    <label for="not-related-reason">Reason<span class="text-danger">*</span></label>
                    <CommentInput
                        input-name="not-related-comments"
                        :result="dme.notRelatedComments"
                        placeholder="Specify rationale and pertinent medical management information."
                        max-length="2000"
                        v-on:resultUpdatedAppended="resultUpdatedAppended"
                        v-on:resultUpdated="resultUpdated"
                    >
                    </CommentInput>
                </div>
            </div>
        </td>
    </tr>
</template>

<script lang="ts" src="./DMETableRow.ts"></script>
